const queryStaleTimes = {
    default: 5 * 1000,
    menu: 5 * 60 * 1000
};

export default queryStaleTimes;
